import {
  CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DEFAULT_LIGHT,
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_BREAKPOINT_XS,
  SYS_SPACE_FIXED_100,
  SYS_SPACE_FIXED_150,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_300,
  SYS_SPACE_FIXED_350,
  SYS_SPACE_FIXED_50,
} from '@oneaudi/unified-web-common';
import {
  SYS_COLOR_SURFACE_INTERACTIVE_CARD_ACTIVE_STROKE_DARK,
  SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK,
} from '@oneaudi/unified-web-alpha-common-v2';
import type { CustomTheme } from '../@types/theme';

const breakpoints = {
  xs: parseInt(SYS_BREAKPOINT_XS, 10),
  sm: parseInt(SYS_BREAKPOINT_SM, 10),
  md: parseInt(SYS_BREAKPOINT_MD, 10),
  lg: parseInt(SYS_BREAKPOINT_LG, 10),
  xl: parseInt(SYS_BREAKPOINT_XL, 10),
  xxl: parseInt(SYS_BREAKPOINT_2_XL, 10),
};

const colorsClassicLight = {
  tagBorderColor: CMP_COLOR_UI_TAG_UNSELECTED_SURFACE_STROKE_DEFAULT_LIGHT,
};

const colorsAlphaDark = {
  cardBackground: SYS_COLOR_SURFACE_INTERACTIVE_CARD_DEFAULT_FILL_DARK, //--Sys-Color-Surface-Interactive-Card-Default-Fill #9aa3b11a
  cardStrokeColor: SYS_COLOR_SURFACE_INTERACTIVE_CARD_ACTIVE_STROKE_DARK, // --Cmp-Color-UI-ProductTile-Surface-Stroke-Default #000000
};

const spacing = {
  fixed50: SYS_SPACE_FIXED_50,
  fixed100: SYS_SPACE_FIXED_100,
  fixed150: SYS_SPACE_FIXED_150,
  fixed200: SYS_SPACE_FIXED_200,
  fixed300: SYS_SPACE_FIXED_300,
  fixed350: SYS_SPACE_FIXED_350,
};

export const lightTheme: CustomTheme = {
  name: 'light',
  type: process.env.IS_LEGACY ? 'legacy' : 'alpha',
  breakpoints,
  easing: 'cubic-bezier(0.75, 0.02, 0.5, 1)',
  colors: colorsClassicLight,
  spacing,
  borderWidth: '1px',
};

export const darkTheme: CustomTheme = {
  name: 'dark',
  type: process.env.IS_LEGACY ? 'legacy' : 'alpha',
  breakpoints,
  easing: 'cubic-bezier(0.75, 0.02, 0.5, 1)',
  colors: colorsAlphaDark,
  spacing,
  borderWidth: '0',
};
